import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import BusinessIcon from '@mui/icons-material/Business';
import { GIS_ZHKH_KEY } from '../gisZhkkh/constants';

export const monthDays = Array.from({ length: 28 }, (_, index) => ({
  val: index + 1,
  opt: index + 1,
}));
export const TELEGRAM_INTEGRATION_BOT = 'https://t.me/mira_readings_bot';

export const hours = Array.from({ length: 24 }, (_, i) => ({ opt: `${i.toString().padStart(2, '0')}:00`, val: i }));

export const integrationType = {
  'reporter.mail': {
    title: 'Email',
    icon: <EmailIcon />,
    fields: {
      send_to: 'Email для оповещения',
      send_at_day: 'День оповещения',
      send_at_hour: 'Час оповещения',
    },
  },
  telegram_bot_integration: {
    title: 'Teлеграм',
    icon: <TelegramIcon />,
    fields: {
      sent_at_day: 'День оповещения',
      sent_at_hour: 'Час оповещения',
    },
  },
  'notifier.mail': {
    title: 'Email',
    icon: <EmailIcon />,
    fields: {
      send_to: 'Email для оповещения',
    },
  },
  mosru: {
    title: 'Mos.ru',
    icon: '/icons/mosru-logo.png',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      pay_code: 'Код плательщика',
    },
  },
  mvk: {
    title: 'Мосводоканал',
    icon: '/icons/mvk-logo.png',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      dog_tag: 'Номер договора',
    },
  },
  penzavodokanal: {
    title: 'Пензаводоканал',
    icon: '/icons/pnzvk.png',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      pay_code: 'Код плательщика',
    },
  },
  mosenergosbyt: {
    title: 'Мосэнергосбыт',
    icon: '/icons/mosenergosbyt.jpg',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      dog_tag: 'Номер договора',
      pay_code: 'Код плательщика',
    },
  },
  sibgenco: {
    title: 'СГК',
    icon: '/icons/sgk.webp',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      pay_code: 'Код плательщика',
    },
  },
  moek: {
    title: 'МОЭК',
    icon: '/icons/moek.png',
    customIcon: true,
    fields: {
      send_at_day: 'День отправки',
      pay_code: 'Код плательщика',
      apartment: 'Номер квартиры',
    },
  },
  'integrations.manual': {
    title: 'Интеграция',
    icon: <CorporateFareIcon />,

    fields: {
      'company_payload.url': 'Сайт компании',
      date: 'День отправки',
      login: 'Логин',
      password: 'Пароль',
    },
  },
  email_template: {
    title: 'Отправка на Email УК',
    icon: <BusinessIcon />,

    fields: {
      email: 'Email управляющей компании',
      login: 'Логин',
      password: 'Пароль',
      'sending_date.day': 'День отправки',
    },
  },
  [GIS_ZHKH_KEY]: {
    title: 'ГИС ЖКХ',
    icon: '/icons/gis.png',
    customIcon: true,
    fields: {
      account_number: 'Лицевой счёт',
      meter_guid: 'Идентификатор счетчика в ГИС ЖКХ',
      send_at_day: 'День отправки',
    },
  },
};

export const isEditableIntegration = ['integrations.manual', 'reporter.mail', 'mvk', 'notifier.mail', 'telegram_bot_integration', 'sibgenco'];
